import { useRef, useState } from "react";
import EnterPhone from "./components/EnterPhone";
import OTPValidationScreen from "./components/OTPValidationScreen";
import PasswordInputScreen from "./components/PasswordInputScreen";
import api_requests from "../../resources/api_requests";
import { useLoggedInGuard } from "../../hooks/auth";
import Spinner from "../../modules/Spinner";
import { useNavigate } from "react-router-dom";
import PasswordResetSuccessfull from "../../modules/modals/PasswordResetSuccessfull";
import { createPortal } from "react-dom";
import utils from "../../resources/utils";
import constant from "../../resources/constant";

const ENTER_PHONE = "ENTER_PHONE";
const OTP_VALIDATION_SCREEN = "OTP_VALIDATION_SCREEN";
const PASSWORD_INPUT_SCREEN = "PASSWORD_INPUT_SCREEN";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [__screen, goTo] = useState(ENTER_PHONE);
  const formDataRef = useRef();
  const otpValidationResponseRef = useRef();
  const [showModal, setModalVisibility] = useState(false);
  const selectedCountry = utils._retrieveData(constant.SELECTED_COUNTRY);

  useLoggedInGuard();

  const SCREENS = {
  [ENTER_PHONE]: (onNext) => (
    <EnterPhone
      selectedCountry={selectedCountry}
      onNext={(data) => onNext(data, ENTER_PHONE)}
    />
  ),

  [OTP_VALIDATION_SCREEN]: (onNext, formData) => (
    <OTPValidationScreen
      onNext={(data) => onNext(data, OTP_VALIDATION_SCREEN)}
      {...formData}
    />
  ),
  [PASSWORD_INPUT_SCREEN]: (onNext, _, isLoading) => (
    <PasswordInputScreen
      onNext={(data) => onNext(data, PASSWORD_INPUT_SCREEN)}
      isLoading={isLoading}
    />
  ),
};

  function handleRegister(password) {
    setLoading(true);
    const { first_name, last_name, email, access_token } =
      otpValidationResponseRef.current;
      const data = {
        first_name: first_name,
        last_name: last_name,
        above18_fair_use: true,
        password,
        country_of_registration: selectedCountry === 'india' ? 'IN' : 'ID',
      };

    if (selectedCountry === 'india') {
      data.email = email.toLowerCase().trim();
    }

    api_requests.update_profile(data, access_token).then((res1) => {
      console.log("from forgot password success", res1);
      // MARK::- HANDLE ERROR HERE
      setLoading(false);
      setModalVisibility(true);
    });
  }

  function onNext(options, screenFrom) {
    if (screenFrom === ENTER_PHONE) {
      formDataRef.current = options;
      goTo(OTP_VALIDATION_SCREEN);
    } else if (screenFrom === OTP_VALIDATION_SCREEN) {
      otpValidationResponseRef.current = options;
      goTo(PASSWORD_INPUT_SCREEN);
    } else if (screenFrom === PASSWORD_INPUT_SCREEN) {
      handleRegister(options);
    }
  }

  function onTimerCompleteOfModal() {
    setModalVisibility(false);
    navigate("/login", { replace: true });
  }

  const screenCb = SCREENS[__screen];

  return (
    <div>
      {screenCb(onNext, formDataRef.current, isLoading)}

      {/** Prelaoding the Spinner */}
      <Spinner hidden />

      {showModal &&
        createPortal(
          <PasswordResetSuccessfull onTimerComplete={onTimerCompleteOfModal} />,
          document.body
        )}
    </div>
  );
};

export default ForgotPassword;
